<template lang="pug">
    
Card(
    v-if="isListContent"
    :class="$style.root"
    padding="blue"
    radius-side="all"
)
    List(
        v-if="isListContent || isCanShowLogo"
        :isCanShowLogo="isCanShowLogo"
    )
    Simple(
        v-else-if="isCanShowLogo"
    )

</template>

<script lang="ts">
import Vue, { computed, ref, watch } from 'vue'

import { Card } from '@/shared/ui/Card'
import { useAppStore } from '@/shared/model'

import List from './List.vue'
import Simple from './Simple.vue'

export default Vue.extend({
    name: 'Header',
    setup() {
        const { state, logoUrl } = useAppStore()

        const isListContent = computed(() => state.merchant?.list?.length)

        const isCanShowLogo = ref(false)

        watch(
            logoUrl,
            newValue => {
                if (newValue) {
                    loadImage(newValue, isCanShowLogo)
                }
            },
            {
                immediate: true,
            }
        )

        return {
            isListContent,
            logoUrl,
            isCanShowLogo,
        }
    },
    components: {
        List,
        Simple,
        Card,
    },
})

function loadImage(source: string, status: Record<'value', boolean>) {
    if (source) {
        const img = new Image()
        img.src = source

        status.value = img.complete

        img.onload = () => {
            status.value = true
        }
    } else {
        status.value = false
    }
}
</script>

<style module lang="scss" src="./Header.module.scss" />
